<template>
  <div class="row">
    <yukyu-menu></yukyu-menu>
    <div class="col-md-10 pt-3" v-if="hasAnyRole('ROLE_ADMIN','ROLE_WORK_READ','ROLE_WORK_ADMIN')">
        <div v-if="hasAnyRole('ROLE_ADMIN','ROLE_WORK_ADMIN')">
            <button class="btn btn-raised btn-outline-info btn-sm m-1" @click="openNew()">
                <i class="fas fa-plus-circle"></i> 新規
            </button>
        </div>
        <div class="col-6 text-right">
            {{ list.length }}件
        </div>

        <!-- New Modal -->
        <!-- 新規ボタンの本体（非表示） -->
        <button type="button" class="btn btn-info m-1" data-toggle="modal" data-target="#default" id="openModal" style="visibility:hidden"></button>
        <div class="modal fade" id="default" tabindex="-1" role="dialog" aria-labelledby="newHolidayModalLabel" aria-hidden="true">
            <div class="modal-dialog modal-lg" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="newHolidayModal">新規登録</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">×</span>
                        </button>
                    </div>
                    <div class="modal-bod p-5">
                        <form method="post" @submit.prevent="upsert(spLeave)">
                            <div class="form-group">
                                <label class="col-12">名前<span class="text-danger">*</span> </label>
                                <input type="text" class="col-9 form-control" v-model="spLeave.name" required="required"/>
                            </div>
                            <div class="form-group">
                                <label class="col-12">年間限度日数 <span class="text-danger">※登録後は変更できません</span></label>
                                <input type="number" class="col-9 form-control" v-model="spLeave.limitDays" :readonly="spLeave.id"/>
                            </div>
                            <div class="form-group">
                                <label class="col-12">説明</label>
                                <textarea rows="4" class="col-9 form-control" v-model="spLeave.description"/>
                            </div>
                            <button type="submit" class="btn btn-primary">
                                <span v-if="spLeave.id">編集</span>
                                <span v-else>追加</span>
                            </button>
                        </form>
                    </div>
                </div>
            </div>
        </div>

        <table class="table table-bordered table-responsive">
            <thead class="thead-light">
            <tr>
                <th>名前</th>
                <th>年間限度日数</th>
                <th>説明</th>
                <th>作成日</th>
                <th>更新日</th>
                <th>編集</th>
                <th>削除</th>
            </tr>
            </thead>
            <tbody th:remove="all-but-first">
            <tr v-for="result in list" :key="result.id">
                <td>{{result.name}}</td>
                <td>{{result.limitDays}}</td>
                <td>{{result.description}}</td>
                <td>{{result.createdAt | datetime}}</td>
                <td>{{result.modifiedAt | datetime}}</td>

                <!-- 編集 -->
                <td>
                    <div v-if="hasAnyRole('ROLE_ADMIN','ROLE_WORK_ADMIN')">
                        <button class="btn btn-raised btn-outline-info btn-sm" @click="openUpdate(result)">
                            <i class="fa fa-edit"></i>編集
                        </button>
                    </div>
                </td>
                <!-- 削除 -->
                <td>
                    <div v-if="hasAnyRole('ROLE_ADMIN','ROLE_WORK_ADMIN')">
                        <modal if="confirmDeleteModal" :ref="`confirmDeleteModal${result.id}`" @ok="deleteHoliday(result.id)"></modal>
                        <button class="btn btn-sm btn-outline-danger" @click="confirmDelete(result)"><i class="fa fa-trash mr-1"></i>削除</button>
                    </div>
                </td>
            </tr>
            </tbody>
        </table>
    </div>
  </div>
</template>

<style>
table#mytable,
table#mytable th,
table#mytable td
{
    border: none !important;
}
</style>

<script>
import SpLeaveAPI from '../../../api/sp-leave-api'
import YukyuMenu from './YukyuMenu.vue'
import Modal from '../../Modal.vue'
import moment from 'moment-timezone'
moment.tz.setDefault("Asia/Tokyo")

export default {
  name: "sp-leave",
  components: {
    YukyuMenu,
    Modal,
  },
  data() {
    return {
      loginUser: {
        role: ''
      },
      invalidLimit: false,
      spLeave: {
          name: '',
          description: '',
          limitDays: null,
      },
      list: [],
      copyList: [],
    }
  },
  watch: {
    '$root.$refs.asnHeader.$data.loginUser': function (val) {
        this.loginUser = val
    },
  },
  mounted () {
    this.getList()
  },
  methods: {
    // --------------------------------------------------
    // 一覧取得
    // --------------------------------------------------
    async getList () {
      $(".close").click()
      this.$root.$refs.loading.$data.show = true
      this.list = await SpLeaveAPI.list()
      this.$root.$refs.loading.$data.show = false
    },
    // --------------------------------------------------
    // 登録/更新
    // --------------------------------------------------
    async upsert (data) {
      this.$root.$refs.loading.$data.show = true
      await SpLeaveAPI.spUpsert(data)
      this.$root.$refs.loading.$data.show = false
      this.getList()
    },
    // --------------------------------------------------
    // 初期化
    // --------------------------------------------------
    init(){
        this.spLeave = {
            name: '',
            description: '',
            limitDays: null,
        }
    },
    // --------------------------------------------------
    // 新規モーダル表示
    // --------------------------------------------------
    openNew(){
        this.init()
        $('#openModal').click()
    },
    // --------------------------------------------------
    // 編集モーダル表示
    // --------------------------------------------------
    openUpdate(spLeave){
        this.spLeave = spLeave
        $('#openModal').click()
    },
    // --------------------------------------------------
    // 削除確認
    // --------------------------------------------------
    confirmDelete (spLeave) {
        const eleName = 'confirmDeleteModal' + spLeave.id
        const message = `
            <p>削除後は選択できなくなります。</p>
            <table class="table" id="mytable">
                <tr class="form-group">
                    <th>名前</th>
                    <td>${spLeave.name}</td>
                </tr>
                <tr class="form-group">
                    <th>年間限度日数</th>
                    <td>${spLeave.limitDays ? spLeave.limitDays : ''}</td>
                </tr>
                <tr class="form-group">
                    <th>説明</th>
                    <td>${spLeave.description}</td>
                </tr>
            </table>
        `
        this.$refs[eleName][0].confirm('確認', message, true)
    },
    // --------------------------------------------------
    // 削除
    // --------------------------------------------------
    async deleteHoliday (id) {
      this.$root.$refs.loading.$data.show = true
      await SpLeaveAPI.delete(id)
      this.$root.$refs.loading.$data.show = false
      this.getList()
    },
    // 権限を持っているか判定
    hasAnyRole: function (...args) {
        for (var i = 0; i < arguments.length; i++) {
            if (this.loginUser.role.includes(arguments[i])) {
                return true
            }
        }
        return false
    }
  },
  filters: {
    datetime: function (data) {
      return moment(data).format('YYYY年MM月DD日 HH:mm')
    },
    // 2桁0埋め
    twoDigit: function (data) {
        return ("0" + data).slice(-2)
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/assets/js/components/admin/yukyu/SpLeave.vue